import { SPageListProps } from 'servisofts-component'
import Actions from './Actions'

import CajaPage from "./Page/CajaPage"
import CajaMovimientoRegistroPage from "./Page/CajaMovimientoRegistroPage"
import CajasAbiertas from './Page/CajasAbiertas'
import DetalleCaja from './Page/DetalleCaja'
import CajasPage from './Page/CajasPage'
import CajasPage2 from './Page/CajasPage/CajasPage2'
import ReciboCaja from './Page/ReciboCaja'
const Pages: SPageListProps = {
    CajaPage,
    CajaMovimientoRegistroPage,
    CajasAbiertas,
    DetalleCaja,
    CajasPage,
    CajasPage2,
    ReciboCaja
}


import cajaReducer from './Reducer/cajaReducer'
import cajaMovimientoReducer from './Reducer/cajaMovimientoReducer'
import cajaTipoMovimientoReducer from './Reducer/cajaTipoMovimientoReducer'
const Reducers = {
    cajaReducer,
    cajaMovimientoReducer,
    cajaTipoMovimientoReducer
}

import CajaMovimiento from './CajaMovimiento'
export default {
    Pages,
    Actions,
    Reducers,
    CajaMovimiento
};